import { createClient } from '@supabase/supabase-js';
import Cookies from 'js-cookie';

export const SUPABASE_URL = 'https://jgprkwhzjwpwmojjlhjj.supabase.co';
// Publishable key (replaces the legacy anon key) - safe to ship to the client, same as before.
export const ANON_KEY = 'sb_publishable_lkJIg1iG2rgcW0qOlSvKdg__O7CLTQw';

const cookieStorage = {
  getItem: (key) => Cookies.get(key) ?? null,
  setItem: (key, value) => Cookies.set(key, value, { expires: 90, sameSite: 'Lax' }),
  removeItem: (key) => Cookies.remove(key),
};

export const supabase = createClient(SUPABASE_URL, ANON_KEY, {
  auth: {
    storage: cookieStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Writes need to run as the logged-in user (so RLS can tell them apart from an anonymous
// visitor), but supabaseHeaders() is called synchronously all over the app. Track the current
// session's access token here so it's available without an await at every call site.
let currentAccessToken = null;

supabase.auth.getSession().then(({ data: { session } }) => {
  currentAccessToken = session?.access_token ?? null;
});

supabase.auth.onAuthStateChange((_event, session) => {
  currentAccessToken = session?.access_token ?? null;
});

export const supabaseHeaders = (write = false) => ({
  apikey: ANON_KEY,
  Authorization: `Bearer ${write && currentAccessToken ? currentAccessToken : ANON_KEY}`,
  ...(write ? { 'Content-Type': 'application/json' } : {}),
});
